import styles from './PatientTableHeader.module.css';

export function PatientTableHeader() {
  return (
    <div className={styles.header}>
      <div></div>
      <div>Cliente</div>
      <div>Piano</div>
      <div className={styles.right}>Aderenza</div>
      <div className={styles.right}>Peso</div>
      <div className={styles.center}>Stato</div>
    </div>
  );
}
